import React, { Fragment } from 'react';
import { Intro, Dropdown } from 'abbot-core';
import img from '../../assets/images/U1-T2-4-1a.svg';

const question1 =
  'Whole Grain Bagel with Peanut Butter or White Bread Toast with Butter';
const question2 = 'Orange Juice with Pulp or Orange Slices';
const question3 = 'Cheeseburger or Slice of Cheese Pizza';

const data = {
  questions: [
    {
      label: question1,
      options: [
        'Whole Grain Bagel with Peanut Butter',
        'White Bread Toast with Butter'
      ]
    },
    {
      label: question2,
      options: ['Orange Juice with Pulp', 'Orange Slices']
    },
    {
      label: question3,
      options: ['Cheeseburger', 'Slice of Cheese Pizza']
    }
  ]
};

const feedback = {
  success: {
    title: 'Great!',
    body: ''
  },
  error: {
    title: 'Almost.',
    body: ''
  },
  retry: {
    title: 'Not quite, give it another try',
    body: ''
  }
};

const correctInput = {
  [question1]: 'Whole Grain Bagel with Peanut Butter',
  [question2]: 'Orange Slices',
  [question3]: 'Slice of Cheese Pizza'
};

export default {
  title: 'Question 1',
  path: '/challenge/question-1',
  content: (
    <Fragment>
      <Intro
        title="Show What You Learned"
        direction="For each pair, select the more nutritious food choice."
        img={img}
      />

      <Dropdown
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={2}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/challenge/Question1.js